import { render } from "./MiRecepcion.vue?vue&type=template&id=713ee6d6"
import script from "./MiRecepcion.vue?vue&type=script&lang=js"
export * from "./MiRecepcion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__